// 钥匙连接或断开
export const USB_KEY = 'usb';
// 指纹板（WM）连接或断开
export const USB_PAD = 'pad';
// 心跳
// TODO: sdk内拼写错误
export const HEARTBEAT = 'heartbeat';

export const READ_PROGRESS = 'OnReadData';

export const DONWLOADING_FINGERPRINT_PROGRESS = 'OnDownloadingFingerprint';

export const DYNAMIC_LOCKNO_COLLECTED = 'OnReadLockId';

export const GETTING_FINGERPRINT = 'OnGetFingerprint';

// 钥匙内存储的事件类型
export const KEY_EVENT_TYPES = {
  UNLOCK_SUCCESS: 1,
  SETTING_SUCCESS: 2,
  SETTING_FAILED: 3,
  EXPIRED_KEY: 4,
  NO_UNLOCK_PERMISSION: 5,
  OUTOF_LOCK_TIME: 6,
  WRONG_SYSCODE: 7,
  BLACKLISTS: 8,
  ERROR_COMMUNICATION: 9,

  // TODO: 剩下的暂时还没写...
};
